<template>
  <div>
    <v-container fluid>
      <!-- <notify-menu></notify-menu> -->
      <v-layout>
        <v-flex>
          <div>
            <v-layout align-end row wrap>
              <v-flex shrink>
                <v-layout row wrap>
                  <v-flex xs6>
                    <div class="form-control" style="position: relative">
                      <div class="labelinputontop">{{ $t('start_date') }}</div>
                      <DatePickerWithoutButton v-model="selectedDate.start" @change="onChangeDate">
                        <input :value="DateFormat(selectedDate.start)" readonly type="text" />
                      </DatePickerWithoutButton>
                    </div>
                  </v-flex>
                  <v-flex class="pl-2" xs6>
                    <div class="form-control" style="position: relative">
                      <div class="labelinputontop">{{ $t('end_date') }}</div>
                      <DatePickerWithoutButton v-model="selectedDate.end" @change="onChangeDate">
                        <input :value="DateFormat(selectedDate.end)" readonly type="text" />
                      </DatePickerWithoutButton>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="text-xs-left text-sm-right">
                      <!-- <exportxlsx></exportxlsx> -->
                      <span>
                        <v-btn
                          :loading="exportloading"
                          class="ma-0 mb-0"
                          color="grey"
                          outline
                          @click="showExportGroup = true"
                        >
                          <em class="fas fa-file-export mr-1" /> {{ $t('export') }}
                        </v-btn>
                      </span>
                      <!-- <TicketEditDialog
                        :type="'add'"
                        :loading="loading"
                        @addTicket="onAddTicket"
                      ></TicketEditDialog> -->
                      <v-btn color="primary" outline ripple @click="handleGetAllData">
                        <em class="fa fa-refresh" />
                        <span class="pl-2">{{ $t('refresh') }}</span>
                      </v-btn>
                      <v-btn color="primary" depressed @click="showAdvancedSearch = true">
                        <v-icon>search</v-icon>
                        <span class="pl-2">{{ $t('advanced_search') }}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <div>
            <v-layout class="mb-0 pl-2 pt-2" row wrap>
              <v-flex sm5 xs12>
                <v-btn
                  :disabled="selectedTicket && selectedTicket.length == 0"
                  color="primary"
                  @click="showDialogSelectAgent = true"
                >
                  Transfer
                </v-btn>
                <template v-if="isKmbAgent">
                  <v-btn
                    :color="selectedTicket.length === tickets.length ? 'secondary' : 'primary'"
                    :loading="loading"
                    :disabled="tickets.length === 0"
                    @click="handleSelectAllTickets"
                  >
                    <template v-if="selectedTicket.length === tickets.length && tickets.length > 0">
                      <em class="fas fa-minus-square"></em>&nbsp; {{ $t('deselect_all') }}</template
                    >
                    <template v-else>
                      <em class="far fa-check-square"></em>&nbsp;
                      {{ $t('Select All') }}
                    </template>
                  </v-btn>
                </template>
              </v-flex>
              <v-flex class="pt-0" sm7 xs12>
                <div
                  class="text-xs-right"
                  style="display: flex; align-items: center; justify-content: flex-end; gap: 8px"
                >
                  <template v-if="isKmbAgent">
                    <div style="display: flex; align-items: baseline; gap: 8px">
                      <div>
                        {{ $t('ticket_per_page') }}
                      </div>
                      <v-select
                        :value="limit"
                        :items="[10, 25, 50]"
                        hide-details
                        class="ma-0"
                        :style="{ width: '100%', maxWidth: '60px' }"
                        @change="handleRowsPerPageChange"
                      />
                    </div>
                  </template>

                  <v-pagination
                    v-model="page"
                    :length="pagelength"
                    :total-visible="7"
                    @input="changepage"
                  ></v-pagination>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-layout class="mb-0" row wrap>
            <v-flex class="pa-2 mt-0" md3 xs12>
              <TicketFilter
                :filter="filter"
                style="background-color: #eee; border-radius: 8px"
                @onSearch="onSearch"
              />
            </v-flex>
            <v-flex class="pa-2" md9 xs12>
              <div>
                <div
                  class="my-0 pa-3"
                  style="background-color: #eee; border-radius: 10px; min-height: 400px"
                >
                  <div v-if="loading">
                    <scale-loader :color="'grey'" :loading="true" class="mt-5"></scale-loader>
                  </div>
                  <div v-else-if="!tickets.length">
                    <div class="text-xs-center pt-5" style="font-size: 25px">
                      <em class="far fa-folder-open" style="font-size: 50px" />
                      <br />
                      {{ $t('no_data') }}
                    </div>
                  </div>
                  <div v-else-if="!$store.state.loadingAgentGroups">
                    <div v-for="(item, k) in tickets" :key="item.id" class="mb-2">
                      <TicketItem
                        :selected="selectedTicket"
                        :ticket.sync="tickets[k]"
                        @onSelect="handleSelectTicket(item)"
                        @ontransfer="onSearch"
                        @chat="handleChat(item)($event)"
                      ></TicketItem>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showAdvancedSearch" persistent width="600px">
        <AdvancedSearch @close="handleCloseSearch" @onSearch="onSearch"></AdvancedSearch>
      </v-dialog>
    </v-container>
    <v-dialog v-model="showDialogSelectAgent" persistent width="500px">
      <DialogSelectAgent
        v-if="showDialogSelectAgent"
        @close="showDialogSelectAgent = false"
        @selectedAgent="handleTransferTicket"
      />
    </v-dialog>
    <ExportGroup
      v-model="showExportGroup"
      :limit="1000"
      :total="pagetotal"
      filename="ticketlist"
      @onExport="exportData"
    ></ExportGroup>
    <ChatDialog
      v-model="chat.open"
      :ticket-id="chat.ticketId"
      :url="chat.url"
      @input="handleChatDialogInput"
    />
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import TicketItem from './TicketItem.vue'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import AdvancedSearch from './AdvancedSearch.vue'
import ticket3TicketManagementApi from '@/api/ticket3/ticket-management'
import kmbApi from '@/api/kmb'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/api/util'
import DialogSelectAgent from './DialogSelectAgent.vue'
import TicketFilter from './TicketFilter.vue'
import ExportGroup from '@/components/elements/ExportGroup.vue'
import { FEATURE } from '@/constants/feature.js'
import ChatDialog from './ChatDialog.vue'
import { PAGE, PAGE_GROUP } from '@/constants/page'
import { ADMIN_SHOW_FACEBOOK_ONLY } from '@/constants/cimb_wealth'

export default {
  components: {
    DatePickerWithoutButton,
    TicketFilter,
    TicketItem,
    ScaleLoader,
    AdvancedSearch,
    DialogSelectAgent,
    ExportGroup,
    ChatDialog
  },
  data() {
    return {
      exportloading: false,
      limit: 10,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 0,
      loading: false,
      showAdd: false,

      optionsTags: [],
      // id | starttime | endtime | updatetime | adminupdatetime | first_assign_ticket_timestamp | assign_ticket_timestampid | starttime | endtime | updatetime | adminupdatetime | first_assign_ticket_timestamp | assign_ticket_timestamp

      input: {
        search: ''
      },
      filter: {
        search: '',
        sortBy: 'assign_ticket_timestamp',
        channel: 'all',
        priority: '',
        status: ['pending', 'answered'],
        pageid: '',
        tags: [],
        id: '',
        subject: '',
        assignGroupId: '',
        assignSubGroupId: '',
        assignAdminId: '',
        contact_phone: '',
        contact_email: '',
        wrap_up: []
      },
      tickets: [],
      selectedDate: {
        start: moment().subtract(3, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      showAdvancedSearch: false,
      countTicketData: null,
      countTicketLoading: false,
      showDialogSelectAgent: false,
      selectedTicket: [],
      showExportGroup: false,
      chat: {
        open: false,
        ticketId: undefined,
        url: undefined
      },
      admins: []
    }
  },
  computed: {
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot', 'currentLang']),
    isAnanda() {
      return PAGE.ANANDA.includes(this.selectedBot.pageid)
    },
    isAllInOneChatWithTicketSaleConversation() {
      return (this.selectedBot.features || '')
        .split(',')
        .includes(FEATURE.ALL_IN_ONE_CHAT_WITH_TICKET_SALE_CONVERSION)
    },
    isKmbAgent() {
      return [...PAGE.KMB_AGENT].includes(this.selectedBot.pageid)
    }
  },
  async mounted() {
    // this.handleGetTicket3(this.limit, this.offset)
    await this.$store.dispatch('loadAgents')
    await this.$store.dispatch('loadAgentGroups')
    await this.$store.dispatch('loadAgentSubGroups')
    this.handleGetAllData()
  },
  methods: {
    handleSelectAllTickets() {
      if (this.selectedTicket.length === this.tickets.length) {
        this.selectedTicket = []
      } else {
        this.selectedTicket = this.tickets
      }
    },
    handleRowsPerPageChange(val) {
      this.limit = val
      this.handleGetAllData()
    },
    handleSelectTicket(ticket) {
      if (this.selectedTicket.includes(ticket)) {
        this.selectedTicket = this.selectedTicket.filter((el) => el.id !== ticket.id)
      } else {
        this.selectedTicket.push(ticket)
      }
    },
    async handleTransferTicket(value) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          html: `<strong>${vm.$t('confirm_transfer_ticket')} <br/>${value.agent} ${vm.$t(
            'confirm_transfer_ticket_1'
          )}</strong>`,
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.transferTickets(value)
          vm.$store.dispatch('loading')

          if (response && response.status === 204) {
            vm.selectedTicket = []
            vm.onSearch()

            vm.$swal.fire({
              type: 'success',
              html: `<strong>${vm.$t('transfer_ticket_success')}  <br/>  ${value.agent} ${vm.$t(
                'transfer_ticket_success_1'
              )} </strong>`,
              confirmButtonText: vm.$t('ok')
            })
          }
        } else {
          vm.showDialogSelectAgent = true
        }
      } catch (error) {
        console.error(error)
      }
    },
    async transferTickets(value) {
      let selectedTicketId = []
      try {
        const selectedTicket = this.selectedTicket
        if (selectedTicket && selectedTicket.length > 0) {
          selectedTicketId = selectedTicket.map((el) => {
            return { id: el.id, pageid: el.pageid }
          })
        } else {
          return null
        }
        const ticketListByPageId = selectedTicketId.reduce((prev, curr) => {
          if (prev[curr.pageid]) {
            prev[curr.pageid].push(curr.id)
          } else {
            prev[curr.pageid] = [curr.id]
          }
          return prev
        }, [])

        const keys = Object.keys(ticketListByPageId)
        const ticketUpdatePromises = []

        for (const key of keys) {
          if (key && Object.hasOwnProperty.call(ticketListByPageId, key)) {
            ticketUpdatePromises.push(this.saveBatchTickets(key, ticketListByPageId[key], value))
          }
        }

        const ticketUpdateResults = await Promise.all(ticketUpdatePromises)
        const response = ticketUpdateResults.reduce((prev, curr) => {
          if (curr && curr.status === 204) {
            prev.status = 204
          }
          return prev
        }, {})

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async saveBatchTickets(page_id, ids, transferInfo) {
      try {
        const data = {
          page_id: page_id,
          transfer_to_group_id: transferInfo.group ? transferInfo.group : null, // OPTIONAL
          transfer_to_sub_group_id: transferInfo.subgroup ? transferInfo.subgroup : null, // OPTIONAL
          transfer_to_admin_id: transferInfo.agent,
          ticket_id_list: ids
        }

        let response = null
        if (this.isKmbAgent) {
          response = await kmbApi.putTransferMultiTicket({ data: data })
        } else {
          response = await ticket3TicketManagementApi.putTransferMultiTicket({ data: data })
        }

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    formatFilter() {
      var data = {}

      if (this.filter.status) {
        data.status = this.filter.status ? this.filter.status.join(',').toLowerCase() : ''
      }
      if (this.filter.priority) {
        data.priority = this.filter.priority
      }
      if (this.filter.search) {
        data.search = this.filter.search
      }
      if (this.filter.sortBy) {
        data.sort_by = this.filter.sortBy
      }
      if (this.filter.tags) {
        data.tags = this.filter.tags.join(',').toLowerCase()
      }
      if (this.selectedDate.start) {
        data.start_date = this.selectedDate.start
      }
      if (this.selectedDate.end) {
        data.end_date = this.selectedDate.end
      }

      if (this.filter.assignAdminId) {
        data.assignAdminId = this.filter.assignAdminId
      }
      if (this.filter.assignGroupId) {
        data.assignGroupId = this.filter.assignGroupId
      }
      if (this.filter.assignSubGroupId) {
        data.assignSubGroupId = this.filter.assignSubGroupId
      }
      if (this.filter.channel) {
        data.channel = this.filter.channel
      }
      if (this.filter.contact_email) {
        data.contact_email = this.filter.contact_email
      }
      if (this.filter.contact_phone) {
        data.contact_phone = this.filter.contact_phone
      }
      if (this.filter.id) {
        data.id = this.filter.id
      }
      if (this.filter.pageid) {
        data.pageid = this.filter.pageid
      }
      if (this.filter.subject) {
        data.subject = this.filter.subject
      }
      data.sort_type = 'desc'

      if (this.filter.wrap_up && this.filter.wrap_up.length > 0) {
        data.wrap_up = this.filter.wrap_up
          .map((el) => el.value)
          .join(',')
          .toLowerCase()
      }

      return data
    },
    handleFormatTicket(data) {
      const { id, status, tags, ...rest } = data.user || {}
      const { id: group_id, ...groupRest } = data.group || {}
      const { id: subgroup_id, ...subgroupRest } = data.sub_group || {}
      return {
        assignadminid:
          data.ticket && data.ticket.assignadminid ? data.ticket.assignadminid.toString() : null,
        assignedTo:
          data.ticket && data.ticket.assignedTo ? data.ticket.assignedTo.toString() : null,
        assigngroupid:
          data.ticket && data.ticket.assigngroupid ? data.ticket.assigngroupid.toString() : null,
        assignsubgroupid:
          data.ticket && data.ticket.assignsubgroupid
            ? data.ticket.assignsubgroupid.toString()
            : null,
        group_id,
        subgroup_id,
        ...groupRest,
        ...subgroupRest,
        ...rest,
        user_id: id,
        user_status: status,
        user_tags: tags,
        ...data.ticket
      }
    },
    async exportData(callback) {
      if (callback) {
        const vm = this
        const { limit, offset } = callback

        let json = []

        vm.exportloading = true
        let data = {
          page_id: vm.selectedBot.pageid,
          start_date: vm.selectedDate.start,
          end_date: vm.selectedDate.end,
          role: vm.$store.state.privilege.role
        }
        data = { ...data, ...vm.handleFormatDataBeforeGetTicket(data), limit, offset }
        if (
          [PAGE_GROUP.CIMB_WEALTH].includes(this.selectedBot.page_group) &&
          ADMIN_SHOW_FACEBOOK_ONLY.includes(this.$store.state.userid)
        ) {
          data.channel = 'facebook'
        }
        try {
          const response = await ticket3TicketManagementApi.getTicketManagement({ params: data })
          let tickets = []
          if (response.status == 200 && response.data && response.data.data) {
            tickets =
              response.data.data &&
              response.data.data.map((el) => {
                return this.handleFormatTicket(el)
              })
          }

          json = tickets.map((el) => {
            var objData
            objData = {
              ID: el.id ? el.id : '-',
              Priority: el.priority ? el.priority : '-'
            }

            if ([...this.$store.state.oceanlifePage].includes(this.selectedBot.pageid)) {
              let extraExport = {
                คะแนนความพึงพอใจ: el.satisfaction_score ? el.satisfaction_score : '-',
                คะแนนในการแนะนำบริการ: el.recommendation_score ? el.recommendation_score : '-'
              }
              Object.assign(objData, extraExport)
            }

            let adminTakeTime =
              (vm.isAnanda
                ? this.durationTime(el.first_admin_first_response_time, el.endtime)
                : el.first_admin_first_response_time && el.endtime
                ? this.transformDurationTime(
                    this.diffSecond(el.endtime, el.first_admin_first_response_time)
                  )
                : '-') || '-'

            const channel = this.$store.state.nestlePages.some(
              (page) => page.pageid == this.selectedBot.pageid
            )
              ? this.selectedBot.pagename
              : el.app

            const createName = (firstName, lastName) =>
              [firstName || '', lastName || ''].join(' ').trim()

            Object.assign(objData, {
              ID: el.id ? el.id.toString() : '-',
              Priority: el.priority ? el.priority : '-',
              Name:
                createName(
                  el.contact_firstname || el.first_name,
                  el.contact_lastname || el.last_name
                ) || '-',
              'Latest Email': el.contact_email || el.email || '-',
              'Phone Number': el.contact_phone || el.phoneno || '-',
              Channel: channel ? channel : '-',
              Subject: el.subject ? el.subject : '-',
              Details: el.details ? el.details : '-',
              Status: el.status ? el.status : '-',
              Comment: el.comment ? el.comment : '-',
              'Start time (Date)': el.starttime ? moment(el.starttime).format('DD/MM/YYYY') : '-',
              'Start time (Time)': el.starttime ? moment(el.starttime).format('HH:mm:ss') : '-',
              'First Assigned Admin': el.first_assign_admin_id || '-',
              'First Assigned Admin Display Name': (() => {
                const agent = vm.$store.state.agents.find(
                  (agent) => agent.adminid === el.first_assign_admin_id
                )
                return agent && agent.display_name ? agent.display_name : '-'
              })(),
              'First Assigned Admin (Date)': el.first_assign_ticket_timestamp
                ? moment(el.first_assign_ticket_timestamp).format('DD/MM/YYYY')
                : '-',
              'First Assigned Admin (Time)': el.first_assign_ticket_timestamp
                ? moment(el.first_assign_ticket_timestamp).format('HH:mm:ss')
                : '-',
              'Last Assigned Admin': el.assignadminid || el.first_assign_admin_id || '-',
              'Last Assigned Admin Display Name': (() => {
                const agent = vm.$store.state.agents.find(
                  (agent) => agent.adminid === (el.assignadminid || el.first_assign_admin_id)
                )
                return agent && agent.display_name ? agent.display_name : '-'
              })(),
              'Last Assigned Admin (Date)':
                el.assign_ticket_timestamp || el.first_assign_ticket_timestamp
                  ? moment(el.assign_ticket_timestamp || el.first_assign_ticket_timestamp).format(
                      'DD/MM/YYYY'
                    )
                  : '-',
              'Last Assigned Admin (Time)':
                el.assign_ticket_timestamp || el.first_assign_ticket_timestamp
                  ? moment(el.assign_ticket_timestamp || el.first_assign_ticket_timestamp).format(
                      'HH:mm:ss'
                    )
                  : '-',
              'Admin First Response (Date)': el.first_admin_first_response_time
                ? moment(el.first_admin_first_response_time).format('DD/MM/YYYY')
                : '-',
              'Admin First Response (Time)': el.first_admin_first_response_time
                ? moment(el.first_admin_first_response_time).format('HH:mm:ss')
                : '-',
              'Time to First Response':
                el.first_admin_first_response_time && el.first_assign_ticket_timestamp
                  ? this.transformDurationTime(
                      this.diffSecond(
                        el.first_admin_first_response_time,
                        el.first_assign_ticket_timestamp
                      )
                    )
                  : '-',
              ...(vm.isAnanda && {
                'User waiting time':
                  this.durationTime(el.starttime, el.first_admin_first_response_time) || '-'
              }),
              'End Date': el.endtime ? moment(el.endtime).format('DD/MM/YYYY') : '-',
              'End Time': el.endtime ? moment(el.endtime).format('HH:mm:ss') : '-',
              'Admin take time': adminTakeTime,
              'Total Time':
                !!el.starttime && !!el.endtime
                  ? this.transformDurationTime(this.diffSecond(el.endtime, el.starttime))
                  : '-',
              'Due Date': el.duedate ? moment(el.duedate).format('DD/MM/YYYY') : '-',
              Tags: el.tags ? el.tags : '-',
              'Wrap Up': el.wrap_up ? el.wrap_up.join(', ') : '-',
              'Wrap Up Route': el.wrap_up_route
                ? el.wrap_up_route.map((wrapUp) => Object.values(wrapUp).join(' > ')).join(', ')
                : '-',
              ...(this.isAllInOneChatWithTicketSaleConversation && {
                'Sale Type': el.sale_type_status ? el.sale_type_status : '-',
                'Event Name': el.event_name ? el.event_name : '-',
                'Custom Event Name': el.custom_event_name ? el.custom_event_name : '-',
                'Total Sales': el.event_value ? el.event_value : '-',
                Currency: el.event_currency ? el.event_currency : '-'
              })
            })

            return objData
          })

          callback.submitData(json)
        } catch (error) {
          console.error(error)
        } finally {
          vm.exportloading = false
        }
      }
    },
    durationTime(start, end) {
      if (!start || !end) return

      var startTime = start
      var endTime = end
      var seconds = moment
        .duration(
          moment(endTime, 'YYYY/MM/DD HH:mm:ss').diff(moment(startTime, 'YYYY/MM/DD HH:mm:ss'))
        )
        .asSeconds()
      var displayHours = Math.floor(seconds / 3600)
      var displayMinutes = Math.floor(seconds / 60) % 60
      var displaySeconds = seconds % 60
      return `${displayHours}h ${displayMinutes}m ${displaySeconds}s`
    },
    onChangeDate() {
      this.handleGetAllData()
    },
    changepage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.page * vm.limit - vm.limit
        if (vm.page != 1) {
          vm.offset + 1
        }
        this.handleGetAllData()
      }
    },
    onAddTicket() {
      this.onSearch()
    },
    showAddDialog() {
      this.showAdd = true
    },
    addTag(newTag) {
      this.optionsTags.push(newTag)
      this.filter.tags.push(newTag)
    },
    onSearch(payload) {
      if (payload) {
        this.filter.id = payload.ticket_id
        this.filter.subject = payload.ticket_name
        this.filter.group_id = payload.group ? payload.group.id : ''
        this.filter.subgroup_id = payload.subgroup ? payload.subgroup.id : ''
        this.filter.assign_admin_id = payload.agent_name ? payload.agent_name.adminid : ''
        this.filter.contact_phone = payload.phone_number
        this.filter.contact_email = payload.email
        this.filter.tags = payload.tags
      }
      this.handleGetAllData()
      this.handleCloseSearch()
    },
    handleFormatDataBeforeGetTicket(data) {
      const tmpData = { ...data }
      Object.entries(this.filter).forEach(([key, value]) => {
        if (value && value.length) {
          if (Array.isArray(value)) {
            if (typeof value[0] != 'string') {
              Object.assign(tmpData, {
                [key]: value
                  .map((el) => el.value)
                  .join(',')
                  .toLowerCase()
              })
            } else {
              Object.assign(tmpData, { [key]: value.join(',').toLowerCase() })
            }
          } else {
            if (key == 'channel' && value == 'all') {
              //
            } else {
              if (key == 'assign_admin_id') {
                Object.assign(tmpData, { [key]: value })
              } else {
                Object.assign(tmpData, { [key]: value.toLowerCase() })
              }
            }
          }
        }
      })

      return tmpData
    },
    async handleGetAllData() {
      const vm = this

      let data = {
        page_id: vm.selectedBot.pageid,
        start_date: vm.selectedDate.start,
        end_date: vm.selectedDate.end,
        limit: vm.limit,
        offset: vm.offset,
        role: vm.$store.state.privilege.role
      }

      data = { ...data, ...vm.handleFormatDataBeforeGetTicket(data) }

      if (
        [PAGE_GROUP.CIMB_WEALTH].includes(this.selectedBot.page_group) &&
        ADMIN_SHOW_FACEBOOK_ONLY.includes(this.$store.state.userid)
      ) {
        data.channel = 'facebook'
      }

      const allGet = [vm.handleGetTicket3(data)]
      vm.loading = true
      await Promise.all(allGet)
      vm.loading = false
      return true
    },
    async handleGetTicket3(data) {
      this.loading = true
      try {
        const response = await ticket3TicketManagementApi.getTicketManagement({
          params: {
            ...data
          }
        })

        this.loading = false
        if (response.status == 200) {
          const result = response.data.data.map((el) => {
            return this.handleFormatTicket(el)
          })
          this.tickets = result
          this.pagetotal = parseInt(response.data.total)
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async handleGetCountTicket(data) {
      const vm = this
      try {
        if (['studio7'].includes(vm.selectedBot.theme)) {
          if (vm.filter.pageid) {
            const tempSelectPage = vm.$store.state.com7pages.find((el) => {
              return el.pageid == vm.filter.pageid
            })

            if (tempSelectPage) {
              Object.assign(data, { pageSelect: tempSelectPage.name })
            } else {
              Object.assign(data, { pageSelect: 'All' })
            }
          } else {
            Object.assign(data, { pageSelect: 'All' })
          }
        }

        const response = await api.ticket2GetCountTicket(data)

        if (response) {
          vm.countTicketData = response.data
        }
      } catch (error) {
        vm.countTicketLoading = false
        console.error(error)
      }
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    },
    diffSecond(endDate, startDate) {
      const diff = moment(endDate).diff(startDate)
      return diff / 1000
    },
    transformDurationTime(value) {
      const hours = Math.floor(value / 60 / 60)
      const minutes = Math.floor(value / 60) % 60
      const seconds = Math.floor(value % 60)
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`
    },
    handleChat(ticket) {
      return ({ search, inbox, app }) => {
        const url = new URL(
          'https://cms.enterprise.zwiz.app/' + this.currentLang + '/all-in-one-chat-iframe'
        )
        url.searchParams.set('inbox', inbox)
        url.searchParams.set(
          'query',
          JSON.stringify({
            search,
            app
          })
        )
        url.searchParams.set('layout', 'chat-only')

        this.chat = {
          open: true,
          ticketId: ticket.id,
          url: url.toString()
        }
      }
    },
    handleChatDialogInput(value) {
      if (!value) {
        setTimeout(() => {
          this.chat = {
            open: false,
            ticketId: undefined,
            url: undefined
          }
        }, 300)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/TicketList.vue